// src/components/AdminPanel/Sidebar.js
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { db } from "../../firebase";
import { doc, onSnapshot } from "firebase/firestore";

const Sidebar = ({ activeSection, setActiveSection }) => {
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const [isMobileView, setIsMobileView] = useState(false);
  const [logo, setLogo] = useState("");

  const menuItems = [
    { id: "dashboard", icon: "fas fa-home", label: "Dashboard" },
    { id: "jobApplications", icon: "fas fa-id-badge", label: "Job Applications" },
    { id: "reservationApplications", icon: "fas fa-users", label: "Reservation Applications" },
    { id: "interview", icon: "fas fa-clock", label: "Slot Management" },
    { id: "calendar", icon: "fas fa-calendar-alt", label: "Calendar" },
    { id: "PostJobb", icon: "fas fa-briefcase", label: "Jobs" },
    { id: "reservation", icon: "fas fa-calendar-check", label: "Reservations" },
    { id: "contributors", icon: "fas fa-users", label: "Contributors" },
    { id: "certifications", icon: "fas fa-certificate", label: "Manage Certifications" },
    { id: "publicHolidays", icon: "fas fa-umbrella-beach", label: "Public Holidays" },
    { id: "siteSettings", icon: "fas fa-cog", label: "Site Settings" },
  ];

  // 🔹 Check for mobile view
  useEffect(() => {
    const checkMobile = () => {
      const isMobile = window.innerWidth <= 1024;
      setIsMobileView(isMobile);
      setIsMobileOpen(!isMobile);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // 🔥 Fetch Sidebar Logo from Firebase (use sidebarLogo field)
  useEffect(() => {
    const logoRef = doc(db, "logos", "xrSCDlcVzp10becG8bnW");

    const unsubscribe = onSnapshot(logoRef, (docSnap) => {
      if (docSnap.exists()) {
        const data = docSnap.data();
        // 👇 Use sidebarLogo for sidebar, fallback to navbarLogo if not available
        setLogo(data.sidebarLogo || data.navbarLogo || data["navbar logo"] || "");
      }
    });

    return () => unsubscribe();
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("isAdminLoggedIn");
    window.location.href = "/";
  };

  const toggleSidebar = () => {
    setIsMobileOpen(!isMobileOpen);
  };

  const handleMenuItemClick = (id) => {
    setActiveSection(id);
    if (isMobileView) setIsMobileOpen(false);
  };

  return (
    <>
      {/* Mobile Toggle Button */}
      {isMobileView && (
        <button
          className="sidebar-toggle-btn"
          onClick={toggleSidebar}
          aria-label={isMobileOpen ? "Close sidebar" : "Open sidebar"}
        >
          <i className={isMobileOpen ? "fas fa-times" : "fas fa-bars"}></i>
        </button>
      )}

      {/* Overlay */}
      {isMobileView && isMobileOpen && (
        <div
          className="sidebar-overlay"
          onClick={() => setIsMobileOpen(false)}
        />
      )}

      {/* Sidebar */}
      <div
        className={`sidebar ${isMobileOpen ? "open" : "closed"} ${isMobileView ? "mobile" : ""
          }`}
      >
        {/* Sidebar Header */}
        <div className="sidebar-header">
          <Link to="/" onClick={() => isMobileView && setIsMobileOpen(false)}>
            <img
              src={logo || "https://i.postimg.cc/xdqQ5HBK/new-Logo.png"}
              alt="VisionBird Logo"
              className="sidebar-logo"
            />
          </Link>
        </div>

        {/* Sidebar Menu */}
        <div className="sidebar-menu">
          <div className="menu-section">
            {menuItems.map((item) => (
              <button
                key={item.id}
                className={`menu-item ${activeSection === item.id ? "active" : ""}`}
                onClick={() => handleMenuItemClick(item.id)}
              >
                <div className="menu-icon-wrapper">
                  <i className={item.icon}></i>
                </div>
                <span className="menu-label">{item.label}</span>
                {activeSection === item.id && (
                  <div className="active-indicator"></div>
                )}
              </button>
            ))}
          </div>
        </div>

        {/* Sidebar Footer */}
        <div className="sidebar-footer">
          <button className="logout-btn" onClick={handleLogout}>
            <div className="logout-icon">
              <i className="fas fa-sign-out-alt"></i>
            </div>
            <span>Logout</span>
            <div className="logout-hover-effect"></div>
          </button>
        </div>
      </div>
    </>
  );
};

export default Sidebar;